module.exports = __webpack_public_path__ + "static/media/fliki_ai.5ed33728.png";